
import React from "react";
import { ExternalLink } from "lucide-react";

interface SidebarLinksProps {
  hiqaProfileUrl?: string;
  centerName: string;
}

export function SidebarLinks({ hiqaProfileUrl, centerName }: SidebarLinksProps) {
  return (
    <div className="flex flex-wrap gap-3 text-sm pt-2">
      {hiqaProfileUrl && (
        <a
          href={hiqaProfileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 text-grandpal-green-dark hover:text-grandpal-green-darkHover transition-colors"
        >
          <ExternalLink className="h-4 w-4" />
          <span>View HIQA Report</span>
        </a>
      )}
      
      <span className="text-gray-400">|</span>
      
      <a
        href="#about-section-title"
        className="inline-flex items-center gap-1 text-grandpal-green-dark hover:text-grandpal-green-darkHover transition-colors"
      >
        <span>Learn more about {centerName}</span>
      </a>
    </div>
  );
}
